import router from './router';
import AppLayout from '../layout/AppLayout.vue';
import routes from './routes';
import GuestLayout from '../layout/GuestLayout.vue';
import guestRoutes from './guest-routes';
import Registration from '../registration/Registration.vue';

router.addRoutes([
  {
    path: '/',
    component: AppLayout,
    children: routes,
  },
  {
    path: '/',
    component: GuestLayout,
    children: guestRoutes,
  },
  {
    path: '/register',
    component: Registration,
  },
]);
